import {lazy} from "react";
import {authRoles} from "app/auth/authRoles";

const DesignEditPage = lazy(() => import("./DesignEditPage"));

const designEditRoute = [
    {
        path: "/assistant-flow-editor",
        element: <DesignEditPage/>,
        auth: authRoles.admin,
    },
];

export default designEditRoute;